import React, { useEffect, useState} from "react";
import { setConfig } from "./configure";
import Footer from "./components/footer/footer";
import Menu from "./components/menu/menu";
import AppRoutes from "./routes/App.Routes";
import { Col, Container, Row, Accordion } from "react-bootstrap";
import "./App.css";
import { AuthProvider } from "./context/AuthContext";
import CaducidadToken from "./components/sesion/caducidadToken";

import { createTheme, ThemeProvider } from '@mui/material/styles';
// import WarningAmberTwoToneIcon from '@mui/icons-material/WarningAmberTwoTone';
import { ALERT } from "./components/iconsSVG/IconsSVG";
import { AlertProvider } from "./context/AlertContext";

import VerAviso from "./components/VerAviso/VerAviso.jsx";

// import { AlertRenderer } from "./components/alert/AlertRenderer";
import Matomo from "./components/matomo.jsx";

const theme = createTheme({ 
  // Material sobrescribe la font-family definida globalmente.
  //  Aquí no funciona !important
  typography: {
    // ...
  },
});


function App() {

  const [loaded, setLoaded] = useState(false);
  const [activeTab, setActiveTab] = useState("descarga");
  const [activeInnerTab, setActiveInnerTab] = useState("Tomo1");

  useEffect(() => {
    fetch("/bopi/config.json")
      .then((res) => res.json())
      .then((data) => {
        setConfig(data);
        setLoaded(true);
      })
      .catch((err) => {
        console.error("Error cargando config.json:", err);
      });
  }, []);

  if (!loaded) return <div>Cargando configuración…</div>;

  return (
    <ThemeProvider theme={theme}>
      <AuthProvider>
      <Matomo />
      <CaducidadToken />
        <AlertProvider>
        
          <VerAviso  />

          <div className="App m-0 p-0 d-flex flex-column min-vh-100">
            <Menu 
              activeTab={activeTab}
              setActiveTab={setActiveTab}
              activeInnerTab={activeInnerTab}
              setActiveInnerTab={setActiveInnerTab}
              />

            <Container className="my-3 p-0 pt-1 flex-fill ">
              <Row className="m-0 p-0">
                {/* <Col xs={12} md={8}></Col> */}
              {/* <div className="m-0 p-0" >             */}
                {/* <Col xs={12} md="auto" className="d-flex justify-content-center justify-content-md-start mb-3 mb-md-0 m-0 p-0"> */}
                <Col xs={12} md={6} className="d-flex justify-content-center justify-content-md-start mb-3 mb-md-0 m-0 p-0">
                  <img src="/bopi/logoministerio-agenda.png" alt="Logo Gov de España" className="logos-espacios img-fluid" />
                </Col>
                {/* <Col xs={12} md className="text-center"> */}
                {/* <Col xs={12} md className="d-flex justify-content-center justify-content-md-start mb-3 mb-md-0 m-0 p-0 pt-3">
                  <h2 style={{ fontSize: '1.7em', fontWeight: '600', color:'#356ab3'}} className="m-0 p-0 fw-bolder ">
                    versión BETA
                  </h2>
                </Col> */}
              {/* </div> */}
              </Row>
              {/* <Row className="m-0 p-0 pt-1">
                <Accordion defaultActiveKey="0" className="w-100 m-0 p-0">
                  <Accordion.Item eventKey="0" className="header-warning-color">
                    <Accordion.Header style={{ backgroundColor: '#FFF4E5' }} >              
                                           
                      <ALERT size={56} strokeColor="#f5a623" exclamationColor="#000" />

                      <span className="p-0 m-0 ps-3 fw-bold" style={{ color: 'black', fontSize: '16px', fontFamily: "Segoe UI", fontweight: "700 !important" }}>
                        Advertencia
                      </span>
                                            
                    </Accordion.Header>
                    <Accordion.Body style={{ backgroundColor: '#FFF4E5' }}   >
                      <span className="fw-bold fs-6 text-break">
                        <p>
                        Se encuentra en una versión BETA, la consulta oficial del Boletín Oficial de la Propiedad Industrial (BOPI) sigue siendo la obtenida de la versión actual {" "} <a href="https://consultas2.oepm.es/bopiweb">https://consultas2.oepm.es/bopiweb</a>                        
                        </p>                       
                        <p >
                          Para cualquier incidencia o comentario, por favor póngase en contacto con {" "} <a href="mailto:soportefuncional@oepm.es">soportefuncional@oepm.es</a>                        
                        </p>
                      </span>
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>
              </Row> */}
              {/* <Row className="justify-content-md-center  m-0 p-0 pt-3">
                <AlertRenderer />

              </Row> */}
              <Row className="justify-content-md-center  m-0 p-0">
                  <AppRoutes 
                    activeTab={activeTab}
                    setActiveTab={setActiveTab}
                    activeInnerTab={activeInnerTab}
                    setActiveInnerTab={setActiveInnerTab}
                    />
              </Row>
            </Container>
            <Footer />
          </div>
        </AlertProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
